import { FormType } from 'signup-ui-lego-core/constants/FormType';
import Url from 'urlinator/Url';
import { getActiveExperimentsParameters } from '../experiments/ExperimentUtils';
import { getFlowConfig } from '../flow-initial/getFlowConfig';
import { getApplicationLocale, getLocaleName } from '../i18n/LocaleUtils';
import { getPreferredReferrer } from '../i18n/ReferrerUtils';
import { getIntegrationOrFlowKey } from '../routing/getIntegrationOrFlowKey';
import { getQueryParams } from '../routing/getQueryParams';
import { Data } from '../signup-data/DATA';
import { getVerificationType } from '../store/app/selectors';
import { getFlatSignupDataValueMap } from '../store/signup-data/selectors';
import getAppFromLoginRedirectUrl from '../tracking/getAppFromLoginRedirectUrl';
import { getSignupMode } from '../tracking/getSignupMode';
import { getUserDeviceType } from '../utils/deviceUtils';
import trimEmptyValuesFromObject from '../utils/trimEmptyValuesFromObject';
import { parseUtmData } from '../utm/utmHelpers';
import { getLegalConsentOptionsForSignupRequest } from './form-data-utils/getLegalConsentOptions';
import { getSubmitContext } from './form-data-utils/getSubmitContext';
export const getInitialInterestBody = state => {
  const signupData = getFlatSignupDataValueMap(state);
  const queryParams = getQueryParams();
  const utms = parseUtmData(queryParams);
  const signupContext = getSubmitContext(FormType.SignupInterest, state);
  const referrerUrl = new Url(getPreferredReferrer());
  const referrerData = Object.assign({}, referrerUrl.valid && {
    hostname: referrerUrl.hostname,
    pathname: referrerUrl.pathname,
    href: referrerUrl.href,
    search: referrerUrl.search
  });
  const experimentParameters = getActiveExperimentsParameters(state);
  const requiredData = {
    email: signupData[Data.Email],
    flowKey: getIntegrationOrFlowKey()
  };
  const signupProperties = {
    signupType: getFlowConfig().appName,
    signupMode: getSignupMode(),
    signupVersion: 'odyssey',
    signupDevice: getUserDeviceType()
  };
  const optionalData = trimEmptyValuesFromObject(Object.assign({
    firstName: signupData[Data.FirstName],
    lastName: signupData[Data.LastName],
    pageUri: signupContext.pageUri,
    pageName: signupContext.pageName,
    hutk: signupContext.hutk,
    legalConsent: getLegalConsentOptionsForSignupRequest(),
    locale: getLocaleName(),
    shouldSkipValidation: true,
    queryParams,
    signupProperties,
    languageOptions: getApplicationLocale(),
    signupVerificationType: getVerificationType(state),
    applicationId: getAppFromLoginRedirectUrl()
  }, experimentParameters.length !== 0 && {
    experimentParameters
  }, {}, Object.keys(utms).length !== 0 && {
    utms
  }, {}, Object.keys(referrerData).length !== 0 && {
    referrerData
  }));
  return Object.assign({}, requiredData, {}, optionalData);
};